module.exports = __webpack_public_path__ + "18.586ee245.png";